import { Component } from "@angular/core";

@Component({
  selector: "app-accordion",
  standalone: false,
  templateUrl: "./accordion.component.html",
  styleUrls: ["./accordion.component.scss"]
})
export class AccordionComponent {}
